import m from "../../geodata/es2015/brazilLow";
window.am4geodata_brazilLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/brazilLow.js
// module id = null
// module chunks = 